import { Box, InlineStack, Link, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useIntercom } from 'react-use-intercom';

const Footer = () => {
    const { t } = useTranslation();
    const intercom = useIntercom();
    return (
        <Box paddingBlock={'800'}>
            <InlineStack gap={'200'} align="center" blockAlign="center">
                <Text as="p" variant="bodySm">
                    {t('DASHBOARD.HELP')}
                </Text>
                <Link onClick={() => intercom.showNewMessage()}>
                    <Text as="p" variant="bodySm">
                        {t('DASHBOARD.CONTACT_US')}
                    </Text>
                </Link>
            </InlineStack>
        </Box>
    );
};

export default Footer;
